import React, { useRef, useState } from "react";
import loadable from "@loadable/component";
import { useIntersectionObserver } from "../../../../../../common-deprecated/hooks";
import type { UscContext } from "../../../../../shared-logic/types/UscCommonTypes";
import Loader from "../../styles/molecules/Loader";
import * as Styles from "./SimilarCars.styles";

const IntegratedCarFilterResults = loadable(async () => {
    const component = await import(
        /* webpackChunkName: "integrated-car-filter-results-toyota" */
        "../../../../../car-filter-results/components/toyota/IntegratedCarFilterResults"
    );
    return component.default;
});

export type SimilarCarsType = { vehicleForSaleId: string; context: UscContext };

const SimilarCars = ({ vehicleForSaleId, context }: SimilarCarsType): JSX.Element => {
    const similarCarContainerRef = useRef<HTMLDivElement>(null);
    const [showSimilarCars, setShowSimilarCars] = useState<boolean>(false);
    const [similarCarsInitializing, setSimilarCarsInitializing] = useState<boolean>(true);

    useIntersectionObserver(similarCarContainerRef, () => setShowSimilarCars(true), false, { rootMargin: "400px" });

    return (
        <Styles.Wrapper ref={similarCarContainerRef}>
            {showSimilarCars && (
                <>
                    {similarCarsInitializing && <Loader loaderWrapperHeight={400} />}
                    <IntegratedCarFilterResults
                        context={context}
                        similarCarId={vehicleForSaleId}
                        disableFavourite={false}
                        onInitFinish={() => setSimilarCarsInitializing(false)}
                        disableContactDealer={false}
                    />
                </>
            )}
        </Styles.Wrapper>
    );
};

export default SimilarCars;
